import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data_center",
  "use": "icon-data_center-usage",
  "viewBox": "0 0 1146 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1146 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-data_center\"><defs><style></style></defs><path d=\"M1099.995 938.254H46.433a39.004 39.004 0 0 0 0 77.388h1052.479a39.004 39.004 0 0 0 0-77.388M163.753 821.088a36.837 36.837 0 0 0 39.004-39.003V514.786a36.837 36.837 0 0 0-39.004-39.004 36.837 36.837 0 0 0-39.003 39.004v267.299a39.158 39.158 0 0 0 39.003 39.003m273.026 0a36.837 36.837 0 0 0 39.003-39.003V46.433A36.837 36.837 0 0 0 436.78 7.739a36.837 36.837 0 0 0-39.004 38.694v735.652a39.158 39.158 0 0 0 39.004 39.003m234.02 0a36.837 36.837 0 0 0 39.004-39.003V319.768a39.004 39.004 0 0 0-77.388 0v462.317a39.158 39.158 0 0 0 39.004 39.003m272.715 0a36.837 36.837 0 0 0 39.004-39.003V475.782a39.004 39.004 0 0 0-77.388 0v306.303a39.158 39.158 0 0 0 38.384 39.003\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/data_center.svg
// module id = QjNt
// module chunks = 78